export function createAction(type, payload) {
    return payload === undefined ? { type: type } : { type: type, payload: payload };
}
//# sourceMappingURL=createAction.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/typescript-react-redux-utils/es5-module/createAction.js
// module id = 613
// module chunks = 0